import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {not} from '../../conditionalUtils';
import {isDefined} from '../../typecheck';
import {isConferenceStarted} from './isConferenceStarted';

export const isConferenceEnded = (conference?: Nullable<ConferenceApiModel>) =>
  isDefined(conference)
    ? not(isConferenceStarted(conference)) && conference.status === 'past' // TODO: maybe only status check???
    : false;
